<template>
  <div
    class="landing"
    v-touch:start="onSwipeStart"
    v-touch:moving="onSwipe"
    v-if="$tvaMq !== 'mobile' && $tvaMq !== 'tablet'"
  >
    <LandingBackground></LandingBackground>

    <div class="landing__header"><Header></Header></div>

    <transition :name="'fade'">
      <div class="landing__side" >
        <!-- TODO: For now now hide social share -->
        <SocialShare v-if="landingIndex === -1 && !isModalOpen" ></SocialShare>
        <BtnDownload></BtnDownload>
      </div>
    </transition>
    
    <div
      :class="{
        landing__center: true,
      }"
    >
      <transition :name="transition">
        <SourceCover
          v-if="landingIndex >= 0 && !isMenuOpen && !isModalOpen"
        ></SourceCover>
        <MainCover
          v-if="landingIndex === -1 && !isMenuOpen && !isModalOpen"
        ></MainCover>
        <Menu v-if="isMenuOpen"></Menu>
      </transition>

      <!-- [TODO] puoè essere un menù box ? -->
      <transition :name="'fade'">
        <div class="landing__center__links" v-if="!isMenuOpen && !isModalOpen">
          <div
            class="landing__center__links--item"
            v-for="(item, index) in externalLinks"
            :key="index"
            @click="onExternalMenuClick(item)"
          >
            {{ item.text }}
          </div>
        </div>
      </transition>
    </div>

    <transition :name="'fade'">
      <Modal v-if="isModalOpen"></Modal>
    </transition>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import SourceCover from "@/components/SourceCover.vue";
import MainCover from "@/components/MainCover.vue";
import SocialShare from "@/components/SocialShare.vue";
import BtnDownload from "@/components/BtnDownload.vue";
import Menu from "@/components/Menu.vue";
import Modal from "@/components/modal/Modal.vue";
import LandingBackground from "@/components/LandingBackground.vue";

import menuHelper from "@/mixins/menuHelper";
import landingHandler from "@/mixins/landingHandler";

export default {
  mixins: [menuHelper, landingHandler],
  name: "Landing",
  components: {
    Header,
    MainCover,
    SourceCover,
    SocialShare,
    BtnDownload,
    Menu,
    Modal,
    LandingBackground,
  },
};
</script>

<style lang="scss" scoped>
.landing {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;

  &__header {
    pointer-events: none;
    height: toRem($header-HEIGHT);
    width: 100%;

    position: absolute;
    top: 0;
    left: 0;
    z-index: 4;
  }

  &__side {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3; // to be over multiplied background
    width: toRem($landing-side-WIDTH);
    height: 100%;

    border: $white-border;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &__center {
    position: relative;

    flex-grow: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 2;

    height: calc(100vh - toRem($header-HEIGHT));
    margin-top: toRem(10);

    &__links {
      position: fixed;
      bottom: toRem(50);
      right: $landing-margin-right-left;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: toRem(200);

      &--item {
        color: $ui-white;
        @include small-links;
      }
    }
  }
}
</style>
